import { Component, OnInit, Output, EventEmitter, ViewChild, Input } from '@angular/core';
import { NotificationAPIService, NotificationService } from '../_services/notification.service'
import { switchMap } from 'rxjs/operators';
import { PushNotificationsService } from '../_services/push.notification.service';
import { ScrollbarComponent } from 'ngx-scrollbar';
import { VaService } from '../_services/va.service';
import { LongProgressService, ACTIVE_TASK_USER_CONFIG_KEY } from '../_services/long-progress.service';
import { UserService } from '../_services/user.service';
import { AuthContextService } from '../_services/auth.service';
import { Subscription, Observable, interval } from 'rxjs';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  notifications: Array<Object> = []
  unreadCount = 0;
  offset = 0;
  limit = 10;
  loadMoreFalg:any = false;

  // Notification Tab
  activeTab:any = 'info';

  //  Progress bar notification
  progessList = [];

  // Deployment Notification
  deployment_running = false;
  deployment_message= '' ;
  deploymentEvent: Observable<Event>;

  //DuplicateDoc Notification
  duplicateDocStatus: boolean = false;
  similarPairs: any = [];
  currentDate: Date = new Date();
  formattedDate: string;

  endProgressEventSubscription: Subscription;
  notificationOpenEventSubscription: Subscription;

  @Input("showNotification") showNotification: boolean;

  @Output() notificationCount = new EventEmitter<number>();

  @ViewChild(ScrollbarComponent, { static: false }) scrollRef: ScrollbarComponent;

  constructor(private notificationAPIService: NotificationAPIService,
    private _notificationService: PushNotificationsService,
    public _vaService:VaService,
    private longProgressService: LongProgressService,
    private userService: UserService,
    private authContextService: AuthContextService,
    private notificationService: NotificationService,
    private datePipe: DatePipe) {
    this._notificationService.requestPermission();
  }

  ngOnInit() {
    this.notificationAPIService.getNotificationsList(this.offset, this.limit).subscribe(
      (result) => {
        this.unreadCount = result["unread_count"]
        this.notificationCounts();
        this.notifications = result["data"]
        if(result["data"].length < 10){
          this.loadMoreFalg = false;
        }
        else{
          this.loadMoreFalg = true;
        }
      }
    )

    if(this.notificationAPIService.notificationSubscriber) {
      this.notificationAPIService.notificationSubscriber.unsubscribe()
    }
    

    this.notificationAPIService.notificationSubscriber = interval(7000)
      .pipe(
        switchMap(() => this.notificationAPIService.getPushNotification({}))
      )
      .subscribe(
        data => {
          if (data && data.length) {
            this.notifications.push(...data)
            this.unreadCount += data.length
            this.notificationCounts();
            this.showNotifications(data)
          }
        }
        , err => {
          console.log("error")
        })

        this.notificationAPIService.showDeploymentNotificaticationEvent.subscribe(e => {
          this.deployment_running = e.deployment_running;
          this.deployment_message = e.deployment_message;
          this.notificationCounts();
        });

    // long progress notifications
    this.notificationSubscription()
    this.progressEndEvent()
    this.notificationOpenCheck()

    let updatedActivetasks = {};

    var now = new Date(); // today!
    var nowUtc = new Date( now.getTime() + (now.getTimezoneOffset() * 60000));

    var noOfDays = 1; // go back 1 days!
    nowUtc.setDate(nowUtc.getDate() - noOfDays);


    if(this.authContextService.isLoggedIn()) {
      let activetasks = this.userService.getConfig(ACTIVE_TASK_USER_CONFIG_KEY)
      
      for(var key in activetasks) {
        
        if (("created_at" in activetasks[key]) && (new Date(activetasks[key]["created_at"]) >= nowUtc))
        {
          this.longProgressService.resumeProgress(activetasks[key])
          updatedActivetasks[activetasks[key]["activeProjectID"]] = activetasks[key]
        }else{
          console.log("skipping task ------ $$$$$ ", activetasks[key])
        }     
      }
      
      this.userService.setConfig(ACTIVE_TASK_USER_CONFIG_KEY, updatedActivetasks)
    }

    this.notificationService.showDuplicateDocsEvent.subscribe(e => {
      this.duplicateDocStatus = true;
      this.similarPairs = e;
      this.formattedDate = this.datePipe.transform(this.currentDate, 'dd, yyyy h:mm a');
    })
  }

  ngOnDestroy() {
    this.endProgressEventSubscription.unsubscribe();
    this.notificationOpenEventSubscription.unsubscribe();
  }

  closeNotifications() {
    this.showNotification = !this.showNotification
    this.longProgressService.currentNotificationTab.emit(false);
  }
  
  notificationCounts() {
    if(this.deployment_running) {
      this.notificationCount.next(this.unreadCount+this.progessList.length + 1)
    } else{
      this.notificationCount.next(this.unreadCount+this.progessList.length)
    }
  }

  showNotifications(notifications: Array<any> = []) {
    this._notificationService.generateNotification(notifications);
  }

  loadMore() {
    this.offset = this.notifications.length
    this.notificationAPIService.getNotificationsList(this.offset, this.limit).subscribe(
      (result) => {
        this.unreadCount = result["unread_count"]
        this.notificationCounts();
        this.notifications.push(...result["data"])
        if(result["data"].length < 10){
          this.loadMoreFalg = false;
        }
        else{
          this.loadMoreFalg = true;
        }
      }
    )
  }
  markAsRead(notifification_id) {
    this.notificationAPIService.markAsRead(notifification_id).subscribe(
      (success) => {
        this.unreadCount -= 1
        this.notificationCounts();
      }
    )
  }
  navigate(notifification) {
    if (notifification['meta']['path']) {
      window.open(notifification['meta']['path'], '_blank');
    }
  }
  clear(id = null) {
    this.notificationAPIService.clearNotifications(id).subscribe(
      (success) => {
        if (id) {
          this.notifications = this.notifications.filter(
            (item) => { return item["_id"] != id }
          )
          this.unreadCount -= 1
          this.notificationCounts();
        } else {
          this.notifications = []
          this.loadMore()
        }

      }
    )
  }

  tabChange(ids) {
    this.activeTab = ids;
    this.tabCheck();
  }

  tabCheck() {
    if(this.activeTab === 'progress-bar') {
      this.longProgressService.currentNotificationTab.emit({currentTab: 'progress-bar'});
    } else if(this.activeTab === 'alerts') {
      this.longProgressService.currentNotificationTab.emit({currentTab: 'alerts'});
    } else {
      this.longProgressService.currentNotificationTab.emit({currentTab: 'info'});
    }
  }

  notificationSubscription() {
    this.longProgressService.showProgressEvent.subscribe((statusData) => {
      this.progessList.unshift(JSON.parse(JSON.stringify(statusData)));
      this.notificationCounts();
    })
  }
  
  clearProgress() {
    this.progessList = this.progessList.filter(item => item.statusClass !== "SUCCESS" && item.statusClass !== "FAILURE" && item.statusClass !== "REVOKED")
    this.notificationCounts();
  }

  progressEndEvent() {
    this.endProgressEventSubscription = this.notificationService.endProgressEvent.subscribe(data => {
      let index = this.progessList.map(e => e.taskId).indexOf(data.progress.taskId);
      this.progessList[index] = JSON.parse(JSON.stringify(data.progress))
      this.progessList[index].isActive = true
      this.progessList[index].status = data.progress.status
    })
  }

  notificationOpenCheck() {
    this.notificationOpenEventSubscription = this.longProgressService.notificationOpenEvent.subscribe(content => {
      if(content) {
        this.tabCheck();
      } else {
        this.longProgressService.currentNotificationTab.emit(false);
      }
    })
  }

}
